// @vendors
import { EnvelopeIcon, PhoneIcon } from "@heroicons/react/24/solid";
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";

// @helpers
import {
    discordLink,
    instagramLink,
    twiterLink,
    xervixAdmonEmail,
    xervixPhoneNumber,
} from "../../helpers/functionsUtils";

const ContactUsCard = () => {
    const { t } = useTranslation();

    return (
        <div className='w-full flex items-center flex-col gap-[15px] bg-[#F97068] rounded-lg p-[20px]'>
            <h6 className='w-full flex items-center justify-center text-[20px] text-white font-semibold'>
                {t("userProfile.contact.contactInformation")}
            </h6>

            <p className='w-full flex items-center justify-center text-[13px] text-white '>
                {t("userProfile.contact.hasQuestion")}
            </p>

            <div className="w-full flex flex-col lg:flex-row justify-evenly">
                <div className="flex flex-col items-center gap-1">
                    <PhoneIcon className="w-[25px] h-auto text-white" />
                    <p className="w-full flex justify-center text-white text-[13px]">
                        {xervixPhoneNumber}
                    </p>
                </div>

                <div className="flex flex-col items-center gap-1">
                    <EnvelopeIcon className="w-[25px] h-auto text-white" />
                    <p className="w-full flex justify-center text-white text-[13px]">
                        {xervixAdmonEmail}
                    </p>
                </div>
            </div>

            <div className="w-full flex justify-center gap-[20px] mt-4">
                <Link
                    target="_blank"
                    to={twiterLink}
                >
                    <img
                        src="/assets/icons/twiter.svg"
                        alt="Twiter logo"
                        className="w-[25px] h-auto"
                    />
                </Link>

                <Link
                    target="_blank"
                    to={instagramLink}
                >
                    <img
                        src="/assets/icons/instagram.svg"
                        alt="Instagram logo"
                        className="w-[25px] h-auto"
                    />
                </Link>

                <Link
                    target="_blank"
                    to={discordLink}
                >
                    <img
                        src="/assets/icons/discord.svg"
                        alt="Discord logo"
                        className="w-[25px] h-auto"
                    />
                </Link>
            </div>
        </div>
    )
}

export default ContactUsCard